import { createContext } from "react";
const OfflineContext = createContext();
export default OfflineContext;

